export const filter_config = () => ({
  title: 'Audience filters',
  filters: [
    {
      value: 'is_archived',
      label: 'Archived',
      type: 'boolean',
      key: 'is_archived'
    },
    { value: 'created_on', label: 'Date created', key: 'created_on', type: 'range' }
  ]
});
